import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from './Icon';

const ICON_NAMES = {
  vsat: {
    default: 'satellite',
    connected: 'satellite-badge-outline',
    active: 'satellite-badge',
  },
  cell: {
    default: 'signal-thick',
    connected: 'signal-badge-outline',
    active: 'signal-badge',
  },
  wifi: {
    default: 'wifi-thick',
    connected: 'wifi-badge-outline',
    active: 'wifi-badge',
  },
  alternate: {
    default: 'letter-a',
    connected: 'letter-a-circle-outline',
    active: 'letter-a-circle',
  },
  backup: {
    default: 'letter-b',
    connected: 'letter-b-circle-outline',
    active: 'letter-b-circle',
  },
};

const buildIconName = ({ name, isConnected, isActive }) => {
  const config = ICON_NAMES[name];

  if (!config) return '';
  if (isConnected && isActive) return config.active;
  if (isConnected) return config.connected;

  return config.default;
};

const IconConnection = ({
  name,
  isConnected,
  isActive,
  className = '',
  ...props
}) => {
  return (
    <Icon
      name={buildIconName({ name, isConnected, isActive })}
      className={classNames(
        className,
        isConnected ? 'text-success' : 'text-gray',
      )}
      role="status"
      {...props}
    />
  );
};

IconConnection.propTypes = {
  name: PropTypes.oneOf(['vsat', 'cell', 'wifi', 'alternate', 'backup']),
  isConnected: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

export default IconConnection;
